import { Validator } from 'jsonschema';
import polynomialSchema from '../../assets/schemas/ideal_curve/polynomial.json';
import exponentialSchema from '../../assets/schemas/ideal_curve/exponential.json';
import curveSchema from '../../assets/schemas/ideal_curve/curve.json';

function validateCurve(curve) {
  const validator = new Validator();
  validator.addSchema(polynomialSchema, '/polynomial.json');
  validator.addSchema(exponentialSchema, '/exponential.json');
  validator.validate(curve, curveSchema, { throwAll: true });
}

class Curve {
  y = (x) => {
    throw new Error('This needs to be implemented by derived class');
  };

  toJs = () => {
    throw new Error('This needs to be implemented by derived class');
  };
}

export { Curve, validateCurve };
